export const fanPrefix = '603049';

export const PLAN_DESCRIPTIONS = {
    'FREE FINANCING': 'plan.description.four',
    'NO INTEREST/NO PAYMENT': 'plan.description.five',
    'NO PAYMENT/SAME AS CASH': 'plan.description.three',
    'REDUCED RATE': 'plan.description.six',
    'REGULAR REVOLVING': 'plan.description.one',
    'SAME AS CASH': 'plan.description.two',
};

export const PLAN_NAMES = {
    12: 'plan.name.no.interest',
    13: 'plan.name.same.as.cash',
    14: 'plan.name.no.pay',
    16: 'plan.name.free.financing',
    18: 'plan.name.reduced.rate',
    36: 'plan.name.reduced.rate',
    88: 'plan.name.regular.revolving',
    90: 'plan.name.regular.revolving',
};

export const NOTIFICATION_GROUP = {
    ACCOUNT: 'ACCOUNT',
    FEATURE: 'FEATURE',
    SYSTEM: 'SYSTEM',
};

export const NOTIFICATION_TYPE = {
    MERGED_ACCOUNT: 'MERGED_ACCOUNT',
};

export const TOO_MANY_REQUEST_EXCEPTION = 'TooManyRequestsException';

export const CUSTOM_AUTH_CHALLENGE = 'CUSTOM_CHALLENGE';

export const LIMIT_EXCEEDED_EXCEPTION = 'LimitExceededException';

export const UNAUTHORIZED_EXCEPTION = 'NotAuthorizedException';

export const UNEXPECTED_ERROR = 'UnexpectedErrorOccured';
